module.exports = __webpack_public_path__ + "img/play_the_film.48e2191f.png";